import entityColor from "@util/entityColor";

export function getBadgeConfig(variety) {
  switch (variety) {
    case 1:
      return { label: "registration", color: entityColor.effort };
    case 12:
      return { label: "keyword claim", color: entityColor.keyword };
    case 16:
      return { label: "check in", color: "green" };
    case 17:
      return { label: "reading", color: "blue" };
    default:
      return { label: "variety name here", color: "gray" };
  }
}
